/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ServicedeskKbRequestsReportsType from '@jira/spa-apps__servicedesk-kb-requests-reports/src/KbRequestsReportsApp.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { RouteContext } from '@atlassian/react-resource-router';

export const LazyServicedeskKbRequestsReports: LazyComponent<() => React.JSX.Element> =
	lazyForPaint<typeof ServicedeskKbRequestsReportsType>(() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-servicedesk-kb-requests-reports", jiraSpaEntry: "async-servicedesk-kb-requests-reports" */ '@jira/spa-apps__servicedesk-kb-requests-reports/src/KbRequestsReportsApp.tsx'
			),
		),
	);

const AsyncServicedeskKbRequestsReports = ({ match }: RouteContext): React.JSX.Element => {
	const reportType = match.params.reportType || '';
	return (
		<LazyPage
			Page={LazyServicedeskKbRequestsReports}
			pageId={`spa-apps/servicedesk/reports/${reportType}`}
			shouldShowSpinner
		/>
	);
};

export default AsyncServicedeskKbRequestsReports;
